import axios from '@/helpers/http-common';
import { Comment } from '@/types';


const index = (
    page: number = 1,
    perPage: number = 10,
    search: string = '',
    archived: boolean = false,
    sortBy: string = '',
    sortDesc: boolean = false,
) => {
    return axios.get(`/claims?\
page=${page}&\
per_page=${perPage}&\
search=${search}&\
archived=${archived}&\
order_by=${sortBy}&\
order_desc=${sortDesc}`);
};

const show = (id: string) => {
    return axios.get(`/claims/${id}`);
};

const post = (claim: any) => {
    return axios.post(`/claims/`, { claim });
};

const getComments = (id: string, page: number = 1, perPage: number = 10) => {
    return axios.get(`/claims/${id}/comments?page=${page}&per_page=${perPage}`);
};

const postComments = (id: string, claimComment: Comment) => {
    return axios.post(`/claims/${id}/comments`, { claim_comment: claimComment });
};

const putComment = (id: string, claimComment: Comment) => {
    return axios.put(`/claim/comments/${id}`, { claim_comment: claimComment });
};

const getAttachments = (id: string) => {
    return axios.get(`/claims/${id}/attachments`);
};

const postAttachment = (id: string, file: any) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return axios.post(`/claim/comments/${id}/attachments`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const downloadAttachment = (id: string, filename: string) => {
    return axios.get(`/claim/attachments/${id}`, {
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    });
};

const downloadReport = (id: string) => {
    return axios.get(`/claims/${id}/pdf`, {
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'opomin.pdf');
        document.body.appendChild(link);
        link.click();
    });
};

const getContacts = (id: string) => {
    return axios.get(`/claims/${id}/contacts`);
};

const put = (id: string, claim: any) => {
    return axios.put(`/claims/${id}`, { claim });
};

const getPayments = (id: string) => {
    return axios.get(`/claims/${id}/payments`);
};
const getPaymentTypes = () => {
    return axios.get(`/select/paymentTypes`);
};

const getReminders = (id: string) => {
    return axios.get(`/claims/${id}/reminders`);
};

const calculateInterests = (id: string) => {
    return axios.get(`/claims/${id}/calculation`);
};

export const claimService = {
    index,
    show,
    post,
    getComments,
    getContacts,
    put,
    postComments,
    putComment,
    getAttachments,
    postAttachment,
    downloadAttachment,
    downloadReport,
    getPayments,
    getPaymentTypes,
    getReminders,
    calculateInterests,
};
